module.exports = __webpack_public_path__ + "img/l-coin.1cfae2eb.png";